import { buildRoute } from '@direct-frontend/modules-router';
export type NewsParams = { newsId: string };

export const newsRoute = buildRoute('/news');
export const newsItemRoute = buildRoute<NewsParams>('/news/:newsId');
